export const DEFAULT_SECONDARY_COLOUR = '#072636';
export const DEFAULT_SECONDARY_COLOUR_LIGHT = '#39C5E7';
export const DEFAULT_PRIMARY_COLOUR = '#18A8CB';
